import { createAction } from "@reduxjs/toolkit";

export const createExpense = createAction('createExpense');
export const deleteExpense = createAction('deleteExpense');